import { gateBooleanToBoolean } from "@/sg-core";
import { ITokenAuthSuccessResponse } from "../models/GateAuthResponse";
import { IUser, IRole } from "../models/User";

export interface IUserMapper {
    apiToDomain: (res: ITokenAuthSuccessResponse) => IUser;
}

export default {
    apiToDomain: (res: ITokenAuthSuccessResponse): IUser => {
        const henkilo = res.henkilo.gate;

        return ({
            id: res.henkilo.hpr.id,
            email: henkilo.meiliosoite,
            firstname: henkilo.etunimi,
            surname: henkilo.sukunimi,
            fullname: `${henkilo.etunimi} ${henkilo.sukunimi}`,
            initials: henkilo.nimikirjaimet,
            phone: henkilo.puhelin,
            guid: henkilo.guid,
            language: henkilo.kieli,
            roles: res.henkilo.gate.roolit.map((rooli): IRole => ({
                id: rooli.id,
                name: rooli.nimi,
                reference: rooli.viitenimi,
                //@ts-ignore
                showNameDetail: rooli.nayta_nimitiedot ? gateBooleanToBoolean(rooli.nayta_nimitiedot) : false
            })),

            hprPersonId: res.henkilo.hpr.id,
            gateId: henkilo.id,
            yleinenId: res.henkilo.hpr.id,
        });
    },
} as IUserMapper;
